import React from "react";
import { Link } from "react-router-dom";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/** Turn a plain string into an array of text and clickable <a> for URLs */
function linkifyString(str: string, keyPrefix: string): (string | JSX.Element)[] {
  if (!str) return [];
  const parts: (string | JSX.Element)[] = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  URL_REGEX.lastIndex = 0;
  while ((match = URL_REGEX.exec(str)) !== null) {
    if (match.index > lastIndex) {
      parts.push(str.slice(lastIndex, match.index));
    }
    parts.push(
      <a
        key={`${keyPrefix}-url-${key++}`}
        href={match[0]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {match[0]}
      </a>
    );
    lastIndex = URL_REGEX.lastIndex;
  }
  if (lastIndex < str.length) {
    parts.push(str.slice(lastIndex));
  }
  return parts.length ? parts : [str];
}

const processCaption = (caption: string) => {
  const regex = /@\[(.+?)\]\((.+?)\)/g;
  const parts: (string | JSX.Element)[] = [];
  let lastIndex = 0;
  let match;
  let partKey = 0;

  while ((match = regex.exec(caption)) !== null) {
    const [_, name, uuid] = match;

    if (match.index > lastIndex) {
      parts.push(...linkifyString(caption.slice(lastIndex, match.index), `p-${partKey++}`));
    }

    parts.push(
      <Link key={`mention-${uuid}`} to={`/users/${uuid}`}>
        @{name}
      </Link>
    );

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < caption?.length) {
    parts.push(...linkifyString(caption.slice(lastIndex), `p-${partKey++}`));
  }

  return parts;
};

const CaptionComponent = ({ caption }) => {
  if (!caption) return null;
  const processedCaption = processCaption(caption);
  return <div style={{ whiteSpace: "pre-line" }}>{processedCaption}</div>;
};

export { CaptionComponent };
